export const labelStyle = {
  color: 'text.primary',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  marginBottom: '4px'
};

export const container = {
  marginTop: 0,
  width: '100%'
};

export const inputStyle = {
  borderRadius: '8px',
  backgroundColor: 'background.paper',
  height: 40,
  '& .MuiOutlinedInput-input, & .MuiSelect-select': {
    padding: '8px',
    fontSize: 16,
    lineHeight: '24px',
    height: 24,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
    borderWidth: 1
  },
  '& .MuiOutlinedInput-notchedOutline > legend': {
    display: 'none'
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider'
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
    borderWidth: 1
  },
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E5636D'
  }
};

export const helperStyle = {
  color: '#E5636D',
  paddingTop: 0.5,
  marginLeft: 0,
  fontSize: 12
};
